import { useState } from 'react'

import { logger } from 'src/lib/logger'
import StartJourneyPopupBase from 'src/shared/components/ui/popups/start-journey/start-journey-popup-base'
import { useConsumerStartJourney } from 'src/shared/features/consumers/api/use-consumer-start-journey'
import { useToast } from 'src/shared/hooks/use-toast'
import { formatToE164, phoneSchema } from 'src/shared/schemas/forms/consumer-auth'
import { useEventStore } from 'src/shared/store/event-store'

interface ProfileStartJourneyPopupProps {
  isOpen: boolean
  setOpen: (open: boolean) => void
  userId: number
}

export default function ProfileStartJourneyPopup({ isOpen, setOpen, userId }: ProfileStartJourneyPopupProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showSuccessView, setShowSuccessView] = useState(false)
  const { mutateAsync: consumerStartJourney } = useConsumerStartJourney()
  const { toast } = useToast()
  const { gclid, fbclid } = useEventStore()

  const onSubmitPhoneNumber = async (phoneNumber: string) => {
    const parsedData = phoneSchema.safeParse(phoneNumber)
    if (!parsedData.success) {
      toast({
        title: 'Error submitting phone number',
        description: parsedData.error.errors[0].message,
        variant: 'destructive',
      })
      return
    }
    const formattedPhoneNumber = formatToE164(phoneNumber)
    try {
      setIsSubmitting(true)
      if (!userId) {
        throw new Error('User ID is required')
      }
      const requestBody = {
        phoneNumber: formattedPhoneNumber,
        firstName: '',
        lastName: '',
        createdByUserId: userId,
        gclid,
        fbclid,
      }
      await consumerStartJourney(requestBody)
      setShowSuccessView(true)
    } catch (error) {
      logger.error('ProfileStartJourneyPopup, submit phone number error:', error)
      toast({
        title: 'Error submitting phone number',
        description: 'There was an error submitting your phone number. Please try again later.',
        variant: 'destructive',
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <StartJourneyPopupBase
      isOpen={isOpen}
      setOpen={setOpen}
      onSubmit={onSubmitPhoneNumber}
      showSuccessView={showSuccessView}
      isSubmitting={isSubmitting}
    />
  )
}
